module.exports = {
    list: [
        { key: "DAILY", value: "DAY" },
        { key: "WEEKLY", value: "WEEK" },
        { key: "MONTHLY", value: "MONTH" }
    ]
}